<template>
  <div class="leftbar-view elffy-dashboard" :class="{'left-aside-toggle': toggle_aside}">
    <!--Page Container Start Here-->
    <section class="main-container">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-12">
            <div class="material-table-widget dashboard_top_bar">
              <div class="row">
                <div class="col-md-6 col-md-offset-3">
                 <h3 class="text-center" style="margin:6px 0px;"><b>{{filter_year}}年度組織分析 - {{current_client_name}}</b></h3>
                </div> 
                <div class="col-md-3 form-inline text-right display-block">
                  <select v-model="filter_year" class="form-control" @change="queryData">
                    <option v-for="year in year_range" v-bind:value="year">{{year}}</option>
                  </select>
                  <select v-model="filter_sales" class="form-control" @change="queryData">
                    <option value="all">所有客戶</option>
                    <option v-for="client in company_clients" v-bind:value="client.client_tag">{{client.client_name}}</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="widget-wrap padding-0">
              <div class="row">
                <div class="col" v-for="title in deals_title">
                  <h4 class="text-success" v-if="title=='won'">已成交訂單 <span class="pull-right">+</span></h4>
                  <h4 class="text-wanring" v-else-if="title=='open'">洽談中訂單 <span class="pull-right">+</span></h4>
                  <h4 class="text-danger" v-else-if="title=='lost'">已丟失訂單 <span class="pull-right">=</span></h4>
                  <h4 class="text-info" v-else-if="title=='all'">總訂單</h4>

                  <p>{{dealCount(title)}}筆 / {{dealTotal(title)}} / {{dealRate(title)}}</p>
                  </div>
                </div>
              <hr>
              <p>平均成交定金額(成交總金額/成交總數) = {{avgPrice}}</p>
            </div>
            <div class="widget-wrap padding-0">
              <div class="deal_sidebar block-header clearfix"><div class="pull-left"><p>各階段轉換率</p></div></div>
              <div class="widget-container">
                <div class="widget-content">
                  <div class="row">
                    <div class="col" v-for="name in stages_name">
                      <h4>{{name}}</h4>
                      <p>總共{{stages_data[name]}}筆 <span class="badge badge-pill badge-primary">{{stageRate(stages_data[name])}}</span></p>
                      <p>轉換率 <span class="badge badge-pill badge-primary">{{transferRate(stages_data[name], name)}}</span></p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="widget-wrap padding-0">
              <div class="deal_sidebar block-header clearfix"><div class="pull-left"><p>每月概覽</p></div></div>
              <div class="widget-container">
                    <div id="chartdiv" style="width: 100%; height: 400px;"></div>

                圖表放置區
              </div>
            </div>
          </div> 
        </div>
      </div>
    </section>
    <!--Page Container End Here-->
  </div>
</template>

<script>
  import { getCookie, setCookie } from '@/assets/js/elffy_js/cookie.js'

  export default {
    name: 'clients',
    data() {
      return {
        company_clients: [],
        current_year: '',
        deals_data: '',
        stages_data: '',
        year_range: '',
        filter_sales: '',
        filter_year: '',
        current_client_name: '',
        deals_title: ['open', 'won', 'lost', 'all'],
        stages_name: [],
        chart_data: []
      }
    },
    created() {
      this.getClient();
    },
    props: ['toggle_aside'],
    computed:{
      avgPrice(){
        if(this.deals_data)
          var avg = this.deals_data.total['won'] / this.deals_data.count['won']
          if (isNaN(avg))
            avg = 0
          return 'NT$ ' + avg.toLocaleString();
      }
    },
    methods: {
      dealCount(title){
        if(this.deals_data)
          return this.deals_data.count[title]
      },
      dealTotal(title) {
        if(this.deals_data)
          return 'NT$ ' + this.deals_data.total[title].toLocaleString();
      },
      dealRate(title) {
        if(this.deals_data)
           if (this.deals_data.count['all'] == 0 && this.deals_data.count[title] == 0)
            return '0%'
          else
            return (this.deals_data.count[title]/this.deals_data.count['all']*100).toFixed(2) + '%'
      },
      stageRate(stage_count){
        var first_stage = this.stages_name[0]
        if (stage_count == 0 && this.stages_data[first_stage] == 0)
          return '0%'
        else
        return (stage_count / this.stages_data[first_stage] * 100).toFixed(2) + '%'
      },
      transferRate(stage_count, name){
        if (name == this.stages_name[0] && stage_count==0)
          return '0%'
        else if (name == this.stages_name[0])
          return '100%'


        var previous_index = this.stages_name.indexOf(name) - 1
        var previous_stage = this.stages_name[previous_index]
        if (stage_count == 0 && this.stages_data[previous_stage] == 0)
          return '0%'
        else
          return (stage_count / this.stages_data[previous_stage] * 100).toFixed(2) + '%'
      },
      getClient(){
        const vm = this;
        // user access token
        vm.auth_token = { 'Auth-Token': getCookie('auth_token') }
        this.axios.get('analytics/clients').then(
          function(response) {
            if (response.status == 200 && response['data']['data']) {
              // company_clients
              vm.company_clients = response['data']['data']['company_clients']
              // initial deal_owner_user
              vm.filter_sales = response['data']['data']['current_client']['id']
              vm.current_client_name = response['data']['data']['current_client']['name']
              vm.filter_year = response['data']['data']['current_year']
              vm.year_range = response['data']['data']['year_range']
              vm.deals_data = response['data']['data']['deals_data']
              vm.stages_data = response['data']['data']['stages_data']
              vm.stages_name = response['data']['data']['stages_name']
              vm.chart_data = response['data']['data']['chart_data']
              vm.generateChart(vm.chart_data)
            } else if (response.status == 200 && response['data']['status'] == 'fail') {
              console.log('Error')
            }
          }).catch(function(error) {
          console.log('error:', error)
        });
      },
      queryData(){
        const vm = this;
        // user access token
        vm.auth_token = { 'Auth-Token': getCookie('auth_token') }
        this.axios.get('analytics/query_client_data', {
          params: {
            'client': {'id': vm.filter_sales, 'year': vm.filter_year},
            }
          }).then(
          function(response) {
            if (response.status == 200 && response['data']['data']) {
              vm.current_client_name = response['data']['data']['current_client']['name']
              vm.deals_data = response['data']['data']['deals_data']
              vm.stages_data = response['data']['data']['stages_data']
              vm.chart_data = response['data']['data']['chart_data']
              vm.generateChart(vm.chart_data)
            } else if (response.status == 200 && response['data']['status'] == 'fail') {
              console.log('Error')
            }
          }).catch(function(error) {
        });
      },
      generateChart(chart_data){
        AmCharts.makeChart("chartdiv", {
                  "type": "serial",
                  "theme": "light",
                  "legend": {
                      "equalWidths": false,
                      "useGraphSettings": true,
                      "valueAlign": "left",
                      "valueWidth": 120
                  },
                  "dataProvider": chart_data,
                  "valueAxes": [{
                      "id": "totalmoneyAxis",
                      "axisAlpha": 0,
                      "gridAlpha": 0,
                      "position": "left",
                      "title": "總金額"
                  }, {
                      "id": "avgmoneyAxis",
                      "axisAlpha": 0,
                      "gridAlpha": 0,
                      "labelsEnabled": false,
                      "position": "right"
                  }, {
                      "id": "orderAxis",
                      "axisAlpha": 0,
                      "gridAlpha": 0,
                      "inside": true,
                      "position": "right",
                      "title": "訂單數"
                  }],
                  "graphs": [{
                      "balloonText": "總成交金額:[[value]]",
                      "bullet": "round",
                      "bulletBorderAlpha": 1,
                      "useLineColorForBulletBorder": true,
                      "bulletColor": "#FFFFFF",
                      "bulletSizeField": "townSize",
                      "dashLengthField": "dashLength",
                      "descriptionField": "townName",
                      "labelPosition": "right",
                      "labelText": "[[townName2]]",
                      "legendValueText": "[[value]]元",
                      "title": "總成交金額",
                      "fillAlphas": 0,
                      "valueField": "totalmoney",
                      "valueAxis": "totalmoneyAxis"
                  }, {
                      "balloonText": "平均成交金額:[[value]]",
                      "bullet": "round",
                      "bulletBorderAlpha": 1,
                      "useLineColorForBulletBorder": true,
                      "bulletColor": "#FFFFFF",
                      "bulletSizeField": "townSize",
                      "dashLengthField": "dashLength",
                      "descriptionField": "townName",
                      "labelPosition": "right",
                      "labelText": "[[townName2]]",
                      "legendValueText": "[[value]]元",
                      "title": "平均成交金額",
                      "fillAlphas": 0,
                      "valueField": "avgmoney",
                      "valueAxis": "totalmoneyAxis"
                  }, {
                      "balloonText": "訂單數:[[value]]",
                      "bullet": "square",
                      "bulletBorderAlpha": 1,
                      "bulletBorderThickness": 1,
                      "dashLengthField": "dashLength",
                      "legendValueText": "[[value]]",
                      "title": "訂單數",
                      "fillAlphas": 0,
                      "valueField": "order",
                      "valueAxis": "orderAxis"
                  }],
                  "chartCursor": {
                      "categoryBalloonDateFormat": "YYYY-MM",
                      "cursorAlpha": 0.1,
                      "cursorColor":"#000000",
                       "fullWidth":true,
                      "valueBalloonsEnabled": false,
                      "zoomable": false
                  },
                  "dataDateFormat": "YYYY-MM",
                  "categoryField": "date",
                  "categoryAxis": {
                      "dateFormats": [{
                          "period": "DD",
                          "format": "DD"
                      }, {
                          "period": "WW",
                          "format": "MMM DD"
                      }, {
                          "period": "MM",
                          "format": "MMM"
                      }, {
                          "period": "YYYY",
                          "format": "YYYY"
                      }],
                      "parseDates": true,
                      "autoGridCount": false,
                      "axisColor": "#555555",
                      "gridAlpha": 0.1,
                      "gridColor": "#FFFFFF",
                      "gridCount": 12
                  },
                  "export": {
                    "enabled": true
                   }
              });
      }
    },
  }
</script>


// WEBPACK FOOTER //
// Clients.vue?0147e3c7